module.exports = __webpack_public_path__ + "static/img/cover11.1c13e5d4.jpg";